import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=a315dd40"
import script from "./GroupsList.vue?vue&type=script&lang=ts"
export * from "./GroupsList.vue?vue&type=script&lang=ts"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=a315dd40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports